import api from './client';
import type { ApiResponse, LoginResponse, MeResponse } from '../../types/api';
import type { User, RegisterData } from '../../types';

export const login = async (credentials: { email: string; password: string }): Promise<LoginResponse> => {
  try {
    console.log('Login attempt:', { email: credentials.email, apiBaseUrl: api.defaults.baseURL });
    const response = await api.post<any, LoginResponse>('/api/auth/login', credentials);
    
    if (!response.token || !response.user) {
      console.error('Invalid login response:', response);
      throw new Error('Invalid login response from server');
    }
    
    console.log('Login successful:', { userId: response.user.id, role: response.user.role });
    return response;
  } catch (error) {
    console.error('Login error:', error);
    throw error;
  }
};

export const getCurrentUser = async (): Promise<MeResponse> => {
  try {
    const response = await api.get<any, User>('/api/auth/me');
    return {
      success: true,
      user: response
    };
  } catch (error) {
    console.error('Get current user error:', error);
    throw error;
  }
};

export const register = async (userData: RegisterData): Promise<ApiResponse> => {
  try {
    const response = await api.post<any, ApiResponse>('/api/auth/register', userData);
    if (!response.success) {
      throw new Error(response.message || 'Registration failed');
    }
    return response;
  } catch (error) {
    console.error('Registration error:', error);
    throw error;
  }
};

export const verifyEmail = async (token: string): Promise<ApiResponse> => {
  return api.get<any, ApiResponse>(`/api/auth/verify-email/${token}`);
};

export const forgotPassword = async (email: string): Promise<ApiResponse> => {
  return api.post<any, ApiResponse>('/api/auth/forgot-password', { email });
};

export const resetPassword = async (token: string, password: string): Promise<ApiResponse> => {
  return api.post<any, ApiResponse>('/api/auth/reset-password', { token, password });
};

export const resendVerification = async (email: string): Promise<ApiResponse> => {
  return api.post<any, ApiResponse>('/api/auth/resend-verification', { email });
};